import { AreaOption } from '../../decoders/AreaOption';
import client from '../client';
import { TApiSubset } from './Subset';

export type TSubsetOptionItem<T> = {
  subset: string;
  footnote: string | null;
  value: T
}

export type TTimeOption = TSubsetOptionItem<{
  time: Array<string>
}>

export type TStepItem = {
  to: string;
  from: string;
  by: string;
}

export type TStepsOption = TSubsetOptionItem<{
  step: Array<TStepItem>
}>

export type TStepLegsOption = TSubsetOptionItem<{
  legs: Array<TStepItem>
}>

export type TStepRangesOption = TSubsetOptionItem<{
  step: Array<string>
}>

export type TGridLegsOption = TSubsetOptionItem<{
  legs: Array<Array<string>>;
}>

export type TGridOption = TSubsetOptionItem<{
  grid: Array<string>
}>

export type TRunOption = TSubsetOptionItem<{
  use: Array<string>
}>

export type TMonthOption = TSubsetOptionItem<{
  fcmonth: Array<{
    from: string;
    to: string;
  }>
}>

export type TParamOption = TSubsetOptionItem<{
  param: Array<string>
}>

export type TParamLevelistOption = TSubsetOptionItem<{
  levelist: Array<string> | Array<Array<string> | { from: string, to: string }>,
  param: Array<string>
}>

export type TLevelistOption = TSubsetOptionItem<{
  levelist: Array<string>;
}>

export type TParamQuantileOption = TSubsetOptionItem<{
  quantile: Array<string> | Array<Array<string>>,
  param: Array<string>
}>

export type TChannelOption = TSubsetOptionItem<{
  channel: Array<string>
}>

export type TTimeStepOption = TSubsetOptionItem<{
  step: Array<Array<string>>;
  time: Array<string>
}>

export type TUseStepOption = TSubsetOptionItem<{
  step: Array<Array<string>>;
  use: Array<string>
}>

export type TNumberOption = TSubsetOptionItem<{
  number: Array<{
    from: string;
    to: string;
    by: string;
  }>
}>

export type THindcastOption = TSubsetOptionItem<{
  hindcast: Array<string>;
}>

export type TDirectionOption = TSubsetOptionItem<{
  direction: Array<string>;
}>

export type TFrequencyOption = TSubsetOptionItem<{
  frequency: Array<string>;
}>


export type TApiSubsetOptions = {
  step?: TStepLegsOption | TStepsOption | TStepRangesOption;
  time?: TTimeOption;
  number?: TNumberOption;
  grid?: TGridLegsOption | TGridOption;
  param?: TParamOption;
  levelist?: TLevelistOption;
  area?: AreaOption;
  use?: TRunOption;
  param_levelist?: TParamLevelistOption;
  param_quantile?: TParamQuantileOption;
  fcmonth?: TMonthOption;
  channel?: TChannelOption;
  time_step?: TTimeStepOption;
  use_step?: TUseStepOption;
  direction?: TDirectionOption;
  frequency?: TFrequencyOption;
  hindcast?: THindcastOption;
};

const fetch = (subsetId: TApiSubset['id']): Promise<TApiSubsetOptions> =>
  client.get(`/subset/${subsetId}/option/`).then(response => response.data);

export {
  fetch
}
